const getters = {
  needSync: state => state.permission.needSync,
  token: state => state.permission.token
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js